import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'

import DeviceDetailsPage from '@/components/DeviceDetailsPage'
import DeviceMessagePage from '@/components/DeviceMessagePage'
import DevicePressurePage from '@/components/DevicePressurePage'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Index',
      name: 'Index',
      component: Index
    },
    {
      path: '/DeviceDetailsPage',
      name: 'DeviceDetailsPage',
      component: DeviceDetailsPage
    },
    {
      path: '/DeviceMessagePage',
      name: 'DeviceMessagePage',
      component: DeviceMessagePage
    },
    {
      path: '/DevicePressurePage',
      name: 'DevicePressurePage',
      component: DevicePressurePage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js